"use client";

import ConfirmDialog from '@/components/ui/ConfirmDialog';

export default function InstagramDeleteDialog({
  open,
  loading,
  title,
  onOpenChange,
  onConfirm,
}: {
  open: boolean;
  loading?: boolean;
  title?: string;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}) {
  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Delete Instagram post"
      description={`This will delete the Instagram post${title ? ` for "${title}"` : ''} from Instagram and clear its local publishing status.`}
      variant="danger"
      confirmText="Delete Instagram Post"
      onConfirm={onConfirm}
      loading={loading ?? false}
    />
  );
}
